/**
 * スタッフロール編集ダイアログ専用i18n定数
 */

export const STAFF_ROLES_I18N = {
  // ステータス
  status: {
    active: $localize`:@@admin.staffRoles.status.active:有効`,
    inactive: $localize`:@@admin.staffRoles.status.inactive:無効`,
  },

  // アカウントグループ
  accountGroup: {
    staff: $localize`:@@admin.staffRoles.accountGroup.staff:スタッフアカウント`,
    user: $localize`:@@admin.staffRoles.accountGroup.user:一般ユーザー`,
  },

  // ダイアログ
  dialog: {
    deleteTitle: $localize`:@@admin.staffRoles.dialog.deleteTitle:登録の削除`,
    deleteMessage: $localize`:@@admin.staffRoles.dialog.deleteMessage:このまま進むと、このページに戻れなくなる可能性があります。よろしいですか？`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.staffRoles.button.close:閉じる`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@admin.staffRoles.message.updateSuccess:更新が完了しました。`,
    updateError: $localize`:@@admin.staffRoles.message.updateError:更新に失敗しました。再度お試しください。`,
    invalidMemberId: $localize`:@@admin.staffRoles.message.invalidMemberId:ERROR: メンバーIDの値が不正です。`,
  },
} as const;

export type StaffRolesI18n = typeof STAFF_ROLES_I18N;
